import { API_BASE } from "@/lib/api-config";
import { authFetch } from "@/lib/authenticated-fetch";
import { getAccessToken } from "@/lib/local-auth";

function messageFromApiErrorBody(body: { error?: unknown }): string {
  const e = body.error;
  if (typeof e === "string") return e;
  return "Permintaan gagal";
}

export async function uploadTimesheetSummary(file: File): Promise<unknown> {
  const token = getAccessToken();
  if (!token) {
    throw new Error("Belum login atau token tidak tersedia.");
  }

  const fd = new FormData();
  fd.append("file", file);

  const res = await authFetch(`${API_BASE}/api/v1/timesheets/upload-summary`, {
    method: "POST",
    body: fd,
  });

  const data = (await res.json().catch(() => ({}))) as { error?: unknown };
  if (!res.ok) {
    console.log(data);
    throw new Error(messageFromApiErrorBody(data));
  }
  return data;
}

